import { Box, Grid, Heading, Separator, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

export interface SettingsSectionProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  layout?: 'split' | 'stacked';
  isLast?: boolean;
}

const SettingsSection = ({
  title,
  description,
  actions,
  children,
  layout = 'split',
  isLast = false,
}: SettingsSectionProps) => {
  const py = { base: 6, md: 8 };

  const header = (
    <VStack align="flex-start" gap={2}>
      <Heading as="h2" size="md">
        {title}
      </Heading>
      {description && (
        <Text fontSize="sm" color="fg.muted">
          {description}
        </Text>
      )}
      {actions && <Box mt={2}>{actions}</Box>}
    </VStack>
  );

  return (
    <>
      {layout === 'split' ? (
        <Grid
          templateColumns={{ base: '1fr', md: '260px 1fr' }}
          gap={{ base: 4, md: 10 }}
          py={py}
          w="full"
        >
          {header}
          <Box>{children}</Box>
        </Grid>
      ) : (
        <Box py={py} w="full">
          {header}
          <Box mt={6}>{children}</Box>
        </Box>
      )}
      {!isLast && <Separator />}
    </>
  );
};

export default SettingsSection;
